import { storage } from "../Firebase/firestore"
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage"
import { v4 as uuidv4 } from "uuid"

class FileStorage {
  /**
   * Uploads a file to Firebase Storage and returns metadata
   * @param {File} file - The file to upload
   * @param {Object} chat - Chat object (used only for folder path)
   * @param {string} senderId - ID of sender (e.g. "supplier")
   * @returns {Promise<Object>} - File metadata
   */
  static async uploadFile(file, chat, senderId) {
    try {
      this.validateFile(file)

      const fileId = `${chat.isGroup ? chat.groupId : chat.chatId}_${senderId}_${Date.now()}_${uuidv4()}`
      const storagePath = `chatFiles/${senderId}/${chat.isGroup ? chat.groupId : chat.chatId}/${fileId}`

      // Upload to Firebase Storage
      const storageReference = storageRef(storage, storagePath)
      await uploadBytes(storageReference, file)
      const fileUrl = await getDownloadURL(storageReference)

      // Return metadata only (❌ no push to DB here)
      return {
        id: fileId,
        url: fileUrl,
        name: file.name,
        type: file.type,
        size: file.size,
        uploadedBy: senderId,
        uploadedAt: Date.now(),
      }
    } catch (error) {
      console.error("Error uploading file:", error)
      throw error
    }
  }

  static validateFile(file) {
    const maxSize = 5 * 1024 * 1024 // 5MB
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ]

    if (file.size > maxSize) throw new Error("File size must be less than 5MB")
    if (!allowedTypes.includes(file.type)) throw new Error("Only PNG, JPEG, PDF, and DOC/DOCX files are allowed")

    return true
  }
}

export default FileStorage
